import {Component, Input, OnInit} from '@angular/core';
import {PaymentService} from '../../services/payment.service';
import {NbDialogRef} from '@nebular/theme';
import Swal, {SweetAlertIcon} from 'sweetalert2';
import {environment} from '../../../environments/environment';
import {LocalDataSource} from 'ng2-smart-table';
import * as moment from 'moment';

@Component({
  selector: 'ngx-history-payment-reference',
  templateUrl: './history-payment-reference.component.html',
  styleUrls: ['./history-payment-reference.component.scss'],
})
export class HistoryPaymentReferenceComponent implements OnInit {

  @Input() station: any;

  history = [];
  loading = false;

  source: LocalDataSource;
  settings = {
    actions: false,
    pager: {
      perPage: 6,
    },
    columns: {
      amount: {
        title: 'Monto',
        filter: true,
      },
      dateCreated: {
        title: 'Fecha de creación',
        filter: true,
      },
      timeDuration: {
        title: 'Duración',
        filter: true,
      },
      status: {
        title: 'Estatus',
        filter: true,
      },
      download: {
        title: 'Descargar',
        type: 'html',
        filter: false,
      },
    },
  };

  constructor(
    private paymentService: PaymentService,
    protected ref: NbDialogRef<HistoryPaymentReferenceComponent>,
  ) { }

  close() {
    this.ref.close(false);
  }

  async ngOnInit() {
    await this.getHistory();
  }

  async getHistory() {
    this.loading = true;
    const [err, response]: any = await this.paymentService.getHistoryByStationId(this.station.id);
    this.loading = false;
    if (err) {
      await this.close();
      await this.alert('Oops, ocurrio intentalo mas tarde', 'error');
      return;
    }
    this.source = new LocalDataSource(await response.data.map(transaction => {
      const reference = transaction.charge.method === 'bank_account' ? transaction.charge.id : transaction.charge.payment_method.reference;
      const baseUrl = transaction.charge.method === 'bank_account' ? environment.urlReceiptSpei : environment.urlReceipt;
      const urlDowloadFile = `<a target="_blank" href="${baseUrl}/${reference}"><img class="hover-cursor-pointer" src="assets/images/icons/download.png" width="20px"></a>`;
      return {
        charge: transaction.charge,
        amount: `$${transaction.amount}.°°`,
        dateCreated: moment.unix(transaction.created_at._seconds).format('ll'),
        status: transaction.status === 'pending' ? 'Pendiente' : transaction.status === 'aprobed' ? 'Aprobada' : 'Error',
        timeDuration: `${transaction.duration} ${transaction.duration === 1 ? 'mes' : 'meses' }`,
        download: urlDowloadFile,
      };
    }));
  }

  async alert(title: string = 'asdasd', icon: SweetAlertIcon = 'success', text: string = '', footer = '') {
    await Swal.fire({
      icon,
      title,
      text,
      footer,
    });
  }

}
